/*
 * Casa Journal article: three small behaviours, no framework.
 *   1. Off/On toggle (.toggle with [data-set] buttons).
 *   2. Scroll highlight for the "In this guide" sidebar (.toc a[aria-current]).
 *   3. Prev/next arrows for the shape rail (.cardsw).
 * The page works without it: the menu links are plain anchors, the toggle shows the lit
 * photo, the rails scroll by touch and keyboard.
 * Idempotent per root (data-ca-ready), cleans up on re-init, re-inits on shopify:section:load.
 */
(function () {
  'use strict';
  var teardown = new WeakMap();

  function init(root) {
    if (!root) return;
    if (teardown.has(root)) { teardown.get(root)(); teardown.delete(root); }
    var cleanups = [];
    function on(el, ev, fn, opts) {
      el.addEventListener(ev, fn, opts);
      cleanups.push(function () { el.removeEventListener(ev, fn, opts); });
    }

    // 1. Off/On toggle
    root.querySelectorAll('.toggle').forEach(function (t) {
      var btns = t.querySelectorAll('[data-set]');
      btns.forEach(function (b) {
        on(b, 'click', function () {
          t.dataset.state = b.dataset.set;
          btns.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        });
      });
    });

    // 2. Sidebar highlight
    var links = [].slice.call(root.querySelectorAll('.toc a[href^="#"]'));
    if (links.length && 'IntersectionObserver' in window) {
      var map = {};
      links.forEach(function (a) { map[a.getAttribute('href').slice(1)] = a; });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          links.forEach(function (a) { a.removeAttribute('aria-current'); });
          var a = map[e.target.id];
          if (a) a.setAttribute('aria-current', 'true');
        });
      }, { rootMargin: '-30% 0px -60% 0px' });
      root.querySelectorAll('.sec').forEach(function (s) { io.observe(s); });
      cleanups.push(function () { io.disconnect(); });
    }

    // 3. Rail arrows
    root.querySelectorAll('.cardsw').forEach(function (w) {
      var r = w.querySelector('.cards');
      var bp = w.querySelector('[data-dir="-1"]');
      var bn = w.querySelector('[data-dir="1"]');
      if (!r || !bp || !bn) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function upd() {
        bp.hidden = r.scrollLeft < 8;
        bn.hidden = r.scrollLeft + r.clientWidth >= r.scrollWidth - 8;
      }
      function go(d) {
        var c = r.querySelector('.pcard-slot');
        var step = (c ? c.getBoundingClientRect().width : 240) + 12;
        r.scrollBy({ left: d * step * 2, behavior: reduce ? 'auto' : 'smooth' });
      }
      on(bp, 'click', function () { go(-1); });
      on(bn, 'click', function () { go(1); });
      on(r, 'scroll', upd, { passive: true });
      on(window, 'resize', upd);
      upd();
    });

    teardown.set(root, function () { cleanups.forEach(function (f) { f(); }); });
  }

  function initAll() {
    document.querySelectorAll('[data-casa-article]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
